import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CallRecordingAnalysisPageComponent } from './analysis/call-recording-analysis-page.component';


const routes: Routes = [{

  title: "CallRecording Analysis",
  path:'CallRecording/Analysis',
  component: CallRecordingAnalysisPageComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CallRecordingPagesRoutingModule { }
